import React from "react";
import NewsletterTwelve from "../component/NewsletterTwelve";

function NewsletterTwelveContainer() {
  return <NewsletterTwelve />;
}

export default NewsletterTwelveContainer;
